import { call, fork, put, takeLatest } from 'redux-saga/effects';
import {
  updateConfigurationDefaultsDone,
  updateConfigurationDefaultsError,
  updateConfigurationDefaultsLoading,
  updateConfigurationDefaultsSuccess
} from '../actions/configurationDefaults';
import { adminApi } from '../api/AdminApi';
import { UPDATE_CONFIGURATION_DEFAULTS } from '../actions/actionTypes';

export function* watchUpdateConfigurationDefaultsSaga () {
  yield takeLatest(UPDATE_CONFIGURATION_DEFAULTS, updateConfigurationDefaultsSaga);
}

export function* updateConfigurationDefaultsSaga ({ tenantId, restrictSelfLaunch, showCodeOfConduct, allowPdfs, allowImages, enableShortLinks }) {
  try {
    yield put(updateConfigurationDefaultsLoading());
    const tenant = yield call(adminApi.updateConfigurationDefaults, tenantId, restrictSelfLaunch,
      showCodeOfConduct, allowPdfs, allowImages, enableShortLinks);
    yield put(updateConfigurationDefaultsSuccess(tenant));
  } catch (error) {
    yield put(updateConfigurationDefaultsError(error));
  } finally {
    yield put(updateConfigurationDefaultsDone());
  }
}

export default [
  fork(watchUpdateConfigurationDefaultsSaga)
];
